import React from "react";
import { Link } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa";
import { useSelector } from "react-redux";
// menu is an object like follows
// [
//     {
//         "id": 1,
//         "url": "/legal",
//         "page": {
//             "id": 1,
//             "slug": "legal",
//             "image": "guacara/blog/post/2025/08/21/cerro_cruz.webp",
//             "title": "Legal",
//             "enabled": true,
//             "promoted": false,
//             "parent_id": null
//         },
//         "label": "Legal",
//         "props": null,
//         "enabled": true,
//         "page_id": 1,
//         "parent_id": null
//     },
//     {
//         "id": 2,
//         "url": null,
//         "page": null,
//         "label": "Municipio",
//         "props": null,
//         "enabled": true,
//         "page_id": null,
//         "parent_id": null,
//         "children": [
//             {
//                 "id": 3,
//                 "url": "/historia",
//                 "page": {
//                     "id": 2,
//                     "slug": "historia",
//                     "image": "guacara/blog/post/2025/08/21/piedra_casimbas.webp",
//                     "title": "Historia",
//                     "enabled": true,
//                     "promoted": false,
//                     "parent_id": null
//                 },
//                 "label": "Historia",
//                 "props": null,
//                 "enabled": true,
//                 "page_id": 2,
//                 "parent_id": 2
//             },
//             {
//                 "id": 4,
//                 "url": "/alcalde",
//                 "page": {
//                     "id": 3,
//                     "slug": "alcalde",
//                     "image": "guacara/blog/post/2025/08/21/alcaldesa_lesbia_castillo.webp",
//                     "title": "Alcalde",
//                     "enabled": true,
//                     "promoted": false,
//                     "parent_id": null
//                 },
//                 "label": "Alcalde",
//                 "props": null,
//                 "enabled": true,
//                 "page_id": 3,
//                 "parent_id": 2
//             }
//         ]
//     }
// ]

const Nav = () => {
  const { menu } = useSelector((state) => state.blog);
  return (
    <nav className="mainmenu-nav">
      <ul className="mainmenu">
        {menu &&
          menu.length > 0 &&
          menu.map((item, index) => (
            <li
              key={index}
              className={item.children ? "menu-item-has-children" : ""}
            >
              <Link to={item.url}>
                {item.label}
                {item.children && <FaAngleDown />}
              </Link>
              {item.children && (
                <ul className="gc-submenu">
                  {item.children.map((child, childIndex) => (
                    <li key={childIndex}>
                      <Link
                        to={
                          child.url?.startsWith("/")
                            ? `/page${child.url}?id=${child.page_id}`
                            : (child.url || "/")
                        }
                      >
                        {child.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}

        <li>
          <Link to={process.env.PUBLIC_URL + "/contact"}>Contacto</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
